var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 8,
    viewBox: "0 0 18 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0L9 8 1 0",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomCaret);
export default __webpack_public_path__ + "static/media/bottomCaret.e3bfa602dd06669bd71a9729d6286eb0.svg";
export { ForwardRef as ReactComponent };